import Vue from 'vue'
import Router, { Route } from 'vue-router'
import { isLoggedIn } from '@/global/auth/services'
import store from '@/config/store/store'
import {
  MODULE_NAME as AUTH_MODULE,
  FETCH_ROUTE_PERMISSIONS,
  FetchRoutePermissionsResult,
  FETCH_USER_DATA,
  LOGOUT
} from '@/global/auth/store/types'
import {
  MODULE_NAME as TOAST_MODULE,
  ADD_TOAST
} from '@/global/toast/store/types'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL
})

// Check for name ensures that the route is loaded
const targetsLoginPage = ({ name }: Route): boolean => name === 'Login'

router.beforeEach(async (to, from, next) => {
  const loggedIn = await isLoggedIn()
  if (loggedIn) {
    await handleLoggedIn(to, next, from)
  } else {
    handleNotLoggedIn(to, next)
  }
})

async function handleLoggedIn(to, next, from): Promise<void> {
  if (targetsLoginPage(to)) {
    next('/')
  } else {
    // TODO: Check Access Permissions for Route
    await store
      .dispatch(`${AUTH_MODULE}/${FETCH_ROUTE_PERMISSIONS}`)
      .then((routePermissions: FetchRoutePermissionsResult) => {
        if (
          routePermissions.routes.some(route => to.path.startsWith(route.path))
        ) {
          next()
        } else {
          returnToPrevious(from, next)
        }
      })
      .catch(err => {
        returnToPrevious(from, next)
      })
    next()
  }
}

function handleNotLoggedIn(to, next): void {
  if (targetsLoginPage(to)) {
    next()
  } else if (to.fullPath === '/' || !to.name) {
    next('/login')
  } else {
    next({
      path: '/login',
      query: { nextRoute: to.fullPath }
    })
  }
}

function returnToPrevious(from, next): void {
  store
    .dispatch(`${TOAST_MODULE}/${ADD_TOAST}`, {
      type: 'error',
      message: 'Access Denied!'
    })
    .then(() => {
      next(from)
    })
    .catch(next(from))
}

export default router
